import { ContentActionView, ContentView } from '../../api/client'
import { faIconName } from '../../util/classNames'
import ContentSidebar from '../content/content-card/ContentSidebar'
import ReplyMetadata from './ReplyMetadata'
import { TrashIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import ConfirmModal from '../ConfirmModal'
import BaseActionButton from '../actions/buttons/BaseActionButton'

type Props = {
    action: ContentActionView
    content: ContentView
    onDelete?: (actionId: number) => void
}

/**
 * An Arwen User's reply to a message.
 */
export default function ReplyUs(props: Props) {
    const { content, action, onDelete } = props
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
    let iconName = faIconName(content.socialMediaServiceName.toLowerCase(), true)

    const handleDeleteClick = () => {
        setShowDeleteConfirm(true)
    }

    const handleConfirmDelete = () => {
        if (onDelete) {
            onDelete(action.id)
        }
        setShowDeleteConfirm(false)
    }

    const handleCancelDelete = () => {
        setShowDeleteConfirm(false)
    }

    return (
        <>
            {/* ContentSidebar is container-responsive; this modal is portalled outside any ContentCard, so it needs its own container or the rail never shows. */}
            <div className="@container h-full grow overflow-hidden">
                <div className="flex h-full flex-row ">
                    <ContentSidebar
                        iconName={iconName}
                        moderationStyle={'safe'}
                        isPublic={true}
                        socialMediaServiceName={content.socialMediaServiceName}
                        rounded={true}
                        isSelected={false}
                    />
                    <div className="flex flex-grow flex-col justify-between pb-2 pl-4 pr-4 pt-3 h-24 h-full">
                        <div>
                            <div className="mb-1 flex flex-row justify-between">
                                <ReplyMetadata action={action} />
                            </div>
                            <div className="mt-1 text-ink-900">{action.message}</div>
                        </div>
                        <div className="mt-1 text-ink-700">
                            <div className="flex flex-row flex-wrap items-end justify-between">
                                <div className="flex flex-col">
                                    {/* Space for future content like classifications if needed */}
                                </div>
                                <div className="flex flex-row items-center">
                                    {onDelete && (
                                        <BaseActionButton
                                            applied={false}
                                            tooltip="Delete this reply"
                                            loading={false}
                                            colour="red"
                                            actionAlreadyApplied={false}
                                            icon={<TrashIcon />}
                                            onActionClick={handleDeleteClick}
                                            isActionQueued={false}
                                            disabled={false}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Delete Confirmation Modal */}
            <ConfirmModal
                open={showDeleteConfirm}
                onClose={handleCancelDelete}
                onConfirm={handleConfirmDelete}
                title="Delete reply"
                description="Are you sure you want to delete your reply? This will delete your reply on the platform and within Arwen. This action cannot be undone."
                confirmLabel="Delete"
                icon={<TrashIcon className="h-6 w-6" aria-hidden="true" />}
            />
        </>
    )
}
